import { formatOfferingAmountOption } from '../utils';

const paymentLinkSelectors = {
  getPaymentLinkMassOffering: state => state.paymentLink.massOffering,
  getIsPaymentLinkAvailable: state => state.paymentLink.isPaymentLinkAvailable,

  // gregorian masses
  getGregorianMass: state => state.paymentLink.gregorianMass,
  getGregorianMassAmount: state => {
    const { gregorianMassAmount } = state.paymentLink;
    return formatOfferingAmountOption(gregorianMassAmount);
  },
};

export default paymentLinkSelectors;
